import { Cookies } from 'react-cookie';

import { MultiCatchTrapData } from '../types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const getSmartMultiTraps = async (slug: string) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get(`/traps/mct/${slug}/`, {
    headers: {
      Authorization: token,
    },
  });
  return data.data as MultiCatchTrapData[];
};
